<template>
	<reportFormWrap
		ref="reportFormWrap"
		:reportid="reportid"
		:orderMenu="orderMenu"
		:settingCols="settingCols"
		:reportName="reportName"
		:exportUrl="exportUrl"
		:getFiltersParams="getFiltersParams"
		:getCustomThroughParams="getCustomThroughParams"
		@clearSearchClick='clearSearchClick'
		:sunTable="sunTable"
		:reportFormUrl="reportFormUrl">
		<FiltersBox slot="filters" ref="filters" @inputEnter='inputEnter'></FiltersBox>
		<IconTip slot="icontip"></IconTip>
	</reportFormWrap>
</template>

<script>
import { cols } from '@/js/reportform/refundOrderItem2.js'
import { orderMenu } from '@/js/reportform/reportformCommon.js'
import reportFormWrap from '@/components/reportform/common/ReportFormWrapBigNew.vue'
import FiltersBox from '@/components/reportform/refundOrderItem/FiltersBox.vue'
import IconTip from '@/components/reportform/refundOrderItem/IconTip.vue'
export default {
	name: 'refundOrderItem2',
	components: {
		reportFormWrap,
		FiltersBox,
		IconTip
	},
	data () {
		return {
			reportid: 'REPORT_REFUND_PRODUCT_000003',
			settingCols: cols,
			reportFormUrl: `${this.$fxBaseApi.urlReport}/report/getRefundProductSumReport`,
			exportUrl: `${this.$fxBaseApi.newExportUrl}/refundProductSumReportImport`,
			orderMenu: orderMenu,
			reportName: 'refundOrderItem',
			sunTable: [
				{
					name: '退单数量',
					key: 'refundidcount'
				},
				{
					name: '退单商品数量',
					key: 'refundquantity'
				},
				{
					name: '退单商品金额',
					key: 'refundmoney'
				}
			]
		}
	},
	mounted () {
		this.$refs.reportFormWrap.initReportForm()
	},
	methods: {
		clearSearchClick () {
			this.$refs.filters.clearSearch()
		},
		inputEnter () {
			return this.$refs.reportFormWrap.searchHandler()
		},
		getFiltersParams () {
			return this.$refs.filters.getFiltersParams()
		},
		getCustomThroughParams () {
			return this.$refs.filters.getFiltersDate()
		}
	}
}
</script>
